<template>
    <NuxtLayout>
        <UiSkipToContent main-content-id="quoteForm" />
        <div id="topBanner"></div>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup>
import { useLDClient } from 'launchdarkly-vue-client-sdk';

const ldClient = ref(null);
const config = useRuntimeConfig();

const beforeunload = async (event) => {
    await ldClient.value
        .flush()
        .then(() => {})
        .catch((err) => {
            console.error('Error', err);
        });
};

onMounted(() => {
    if (config.public.LAUNCH_DARKLY_CLIENT_KEY) {
        ldClient.value = useLDClient();
        window.addEventListener('beforeunload', beforeunload);
    }
});
onUnmounted(() => {
    if (config.public.LAUNCH_DARKLY_CLIENT_KEY) {
        ldClient.value = useLDClient();
        window.removeEventListener('beforeunload', beforeunload);
    }
});
</script>

<style lang="postcss">
@import '~/assets/css/tailwind.css';

@import './assets/css/global.css';
@import '@nuxt-monorepo/base/app/assets/css/animations.css';
@import '@nuxt-monorepo/base/app/assets/css/richtext.css';
</style>
